<div class="max-w-lg bg-card text-normal p-6 rounded-lg shadow-lg ">
    <div class="bg-[#181F32] rounded-2xl p-5">
        <div class="w-full flex flex-row justify-start gap-2 items-center">
            @if (stepJson.showStep > 0) {
                <img src="assets/icons/base/up_arrow.svg" alt="" class="text-white -rotate-90 cursor-pointer" (click)="prevStep()"/>
            }
            <h3 class="text-18  text-normal font-bold" id="donate-heading">
                {{ 'donate'| translate }}
            </h3>
        </div>
        <div class="flex flex-col gap-5 mb-6 p-2">
            <div>
                <app-input
                        [customClasses]="'!h-10'"
                        [formControlItem]="form.controls['name']"
                        [labelClass]="'!text-start'"
                        [label]="'name'| translate"
                        [placeholder]="'Anonymous' | translate"
                        [type]="'text'"
                ></app-input>
            </div>
            <div>
                <app-textarea
                        [rows]="4"
                        [maxSymbols]="whiteLabel?.donationWidgetConfig?.maxSymbols || 200"
                        [formControlItem]="form.controls['description']"
                        [label]="'message'| translate"
                        [placeholder]="'write_your_message' | translate"

                ></app-textarea>
            </div>
        </div>
        <app-stepper-slider [currentStep]="stepJson.showStep">
            <app-single-step>
                <app-donation-widget-item
                        (nextStepE)="nextStep($event)"
                        *ngIf="stepJson.showStep === 0"
                        [form]="form"
                        [prices] = "prices"
                        [stickersEnabled] = "stickersEnabled"
                ></app-donation-widget-item>
            </app-single-step>
            <app-single-step>
                <section *ngIf="stepJson.showStep === 1" aria-labelledby="payment-and-shipping-heading"
                         class="py-16 px-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:w-full lg:max-w-lg lg:pt-0">
                    <app-donation-widget-stickers
                            (nextStepE)="makeOrder($event)"
                            [course]='courseOnSelectedCurrency'
                            [form]="form"
                            [stickers]="stickers"
                    ></app-donation-widget-stickers>
                </section>
            </app-single-step>
            <app-single-step (onUpdate)="nextStep()">
                <section *ngIf="stepJson.showStep === 2" aria-labelledby="payment-and-shipping-heading"
                         class="py-16 px-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:w-full lg:max-w-lg lg:pt-0">
                    <app-donation-widget-form
                            (nextStep)="nextStep($event)"
                            (prevStep)="prevStep()"
                            [form]="form"
                            [services]="productServices"
                    ></app-donation-widget-form>
                </section>
            </app-single-step>
            <app-single-step>
                <section *ngIf="stepJson.showStep === 3" aria-labelledby="payment-and-shipping-heading"
                         class="py-16 px-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:w-full lg:max-w-lg lg:pt-0">
                    <app-donation-widget-youtube-link
                            (nextStepE)="setYoutubeLink($event)"
                    ></app-donation-widget-youtube-link>
                </section>
            </app-single-step>
        </app-stepper-slider>
    </div>
</div>
